export default function ({ app, redirect }) {
  // Check if user is authenticated
  if (!app.$auth.loggedIn) {
    // Redirect to login page
    return redirect('/login');
  }
}
